import { Modal } from "antd";
import { ClienteForm } from "./ClienteForm";
import type { Cliente } from "@/features/clientes/types/cliente";

interface ClienteFormModalProps {
  open: boolean;
  cliente?: Cliente;
  onClose: () => void;
  onSuccess?: (cliente: Cliente) => void;
}

export function ClienteFormModal({ open, cliente, onClose, onSuccess }: ClienteFormModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      destroyOnHidden
      centered
      width="min(1100px, 96vw)"
      title={cliente ? "Editar cliente" : "Novo cliente"}
      className="cliente-form-modal"
    >
      <ClienteForm
        formData={cliente}
        isDialog
        onSuccess={(saved) => onSuccess?.(saved)}
      />
    </Modal>
  );
}
